import {
  flightSearchDataSelector,
  experimentDetailSelector,
  staticInformationSelector,
  correlationIdForLoggingSelector,
  seoOmnitureInfoSelector
} from '../SRP/redux/selectors';
import pushPdtLogging from '@stencil/pdt-logging';
import pushAnalyticsData from '@stencil/analytics';
import getDeviceId from '@stencil/flights-utils/src/get-device-id';
import dateDiff from '@stencil/flights-date-utils/src/date-diff';

export const flightsSeoReducersPdtLoggingThunk = (data, pageUrl = '') => {
  return (dispatch, getState) => {
    const flightSearchData = flightSearchDataSelector(getState());
    const experimentDetails = experimentDetailSelector(getState());
    const staticInformation = staticInformationSelector(getState());
    const correlationIdForLogging = correlationIdForLoggingSelector(getState());

    pushPdtLogging(
      data,
      flightSearchData,
      staticInformation,
      pageUrl,
      experimentDetails,
      correlationIdForLogging
    );
  };
};

const handleOmnitureInfo = (eventInfo, manualEvent, keyName) => {
  if (eventInfo == null || Object.keys(eventInfo).length <= 0) return;

  Object.entries(eventInfo).forEach(([eventKey, val]) => {
    if (eventKey === keyName) {
      let newObj = manualEvent[eventKey];
      eventInfo[eventKey] = Array.isArray(newObj) ? newObj : { ...eventInfo[eventKey], ...newObj };
    } else if (eventInfo[eventKey] && typeof eventInfo[eventKey] == 'object') {
      handleOmnitureInfo(eventInfo[eventKey], manualEvent, keyName);
    }
  });
  return eventInfo;
};

const pushAdobeData = ({ eventName = '', omnitureInfoForLogging = {}, data = {} }) => {
  try {
    if (
      omnitureInfoForLogging == null ||
      Object.keys(omnitureInfoForLogging).length == 0 ||
      omnitureInfoForLogging?.['err'] ||
      !eventName
    )
      return;

    let eventInfo =
      omnitureInfoForLogging?.[eventName] || omnitureInfoForLogging?.['components']?.[eventName];

    if (typeof eventInfo === 'object' && eventInfo !== null && Object.keys(eventInfo).length) {
      eventInfo = JSON.parse(JSON.stringify(eventInfo));
    }

    if (Object.keys(data).length > 0) {
      Object.entries(data).forEach(([key, val]) => {
        eventInfo = handleOmnitureInfo(eventInfo, data, key);
      });
    }
    return eventInfo;
  } catch (err) {
    console.error('Error: ', err);
  }
};

export const flightsAnalyticsLoggingThunk = ({ pdtInfo = {}, gaInfo = {}, omnitureInfo = {} }) => {
  return (dispatch, getState) => {
    const flightSearchData = flightSearchDataSelector(getState());
    const correlationIdForLogging = correlationIdForLoggingSelector(getState());
    const seoOmnitureInfoForLogging = seoOmnitureInfoSelector(getState());
    const experimentDetails = experimentDetailSelector(getState());
    const pageUrl = window ? window.location?.href : '';

    const {
      travelType,
      departure,
      source,
      destination,
      flightClass,
      arrival,
      passengers,
      journeyType
    } = flightSearchData;

    let pdtData = null;
    if (pdtInfo && typeof pdtInfo === 'object' && Object.keys(pdtInfo).length > 0) {
      pdtData = {
        data: pdtInfo,
        flightSearchData,
        correlationIdForLogging,
        pageUrl,
        device_id: getDeviceId() || '',
        experimentDetails
      };
    }

    let gaData = null;
    if (gaInfo && typeof gaInfo === 'object' && Object.keys(gaInfo).length > 0) {
      gaData = {
        ...gaInfo,
        cdFields: {
          cdCatQuery: 'flight_' + travelType.toLowerCase(),
          cdDaysToTravel: dateDiff(new Date(), departure.dateObj),
          cdFlightRoute: source.iata + '-' + destination.iata,
          cdFlightSearchClass: flightClass,
          cdFlightSearchDeparture: departure.yyyymmdd,
          cdFlightSearchDestination: destination.iata,
          cdFlightSearchOrigin: source.iata,
          cdFlightSearchReturnDate: arrival ? arrival.yyyymmdd : null,
          cdFlightSearchTravellers: passengers.adult + passengers.child + passengers.infant,
          cdSubCatQuery: journeyType === 'rt' ? 'Roundtrip' : 'Oneway',
          ABVariation: window?.['AB'] ? window['AB'] : 0,
          device_id: getDeviceId() || '',
          flightsAB_experiment_lumous: ''
        }
      };
    }

    let omnitureData = null;
    if (omnitureInfo && typeof omnitureInfo === 'object' && Object.keys(omnitureInfo).length > 0) {
      let omnitureInfoForLogging = {};
      if (omnitureInfo?.['pageType'] === 'SEO') omnitureInfoForLogging = seoOmnitureInfoForLogging;

      omnitureData = pushAdobeData({
        eventName: omnitureInfo?.['eventName'] || '',
        omnitureInfoForLogging,
        data: omnitureInfo?.['data'] || {}
      });
    }
    pushAnalyticsData(pdtData, gaData, omnitureData);
  };
};

export const flightsAnalyticsLogging = ({
  pdtActionName = '',
  gaActionName = '',
  category = '',
  data = {},
  gaEventLabel = ''
}) => {
  return (dispatch, getState) => {
    let eventLabel = gaEventLabel;
    if (!gaEventLabel && Object.keys(data).length) {
      for (let key in data) {
        eventLabel += `${data[key]}|`;
      }
      eventLabel = eventLabel.substring(0, eventLabel.length - 1);
    }
    const newCategory = `flightsGroundUp_SEORouteHome${category ? `_${category}` : ''}`;

    const pdtInfo = {};
    if (pdtActionName) {
      pdtInfo['action_name'] = pdtActionName;
      pdtInfo['meta_data'] = {
        category: newCategory,
        ...(eventLabel ? { subtype: eventLabel } : null),
        ...data
      };
    }

    dispatch(
      flightsAnalyticsLoggingThunk({
        pdtInfo,
        gaInfo: {
          eventCategory: newCategory,
          eventAction: gaActionName || pdtActionName,
          eventLabel
        }
      })
    );
  };
};
